// extracted by mini-css-extract-plugin
export default {"mentorCard":"_3UCy","profile":"_1BYr","image":"Glds","info":"_1p4f","row":"_1U0V","head":"_1PJI","text":"_39ja","chat":"_19y7"};